import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { font, spacing } from '@mobi/component-library/Theme/Common'

export const HeaderStyled = styled('header')({
  background: hexColors.blueDiamond,
  color: hexColors.white,
  padding: `1.425rem ${spacing.md}`,
})

export const HeaderTitleStyled = styled('h2')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  textTransform: 'none',
  fontWeight: `${font.weight.semibold}`,
  lineHeight: '28px',
  fontFamily: 'Inter',
  padding: `${spacing.smx2}`,
})
